import { FormikValues } from "formik";

export const isFormFieldValid = (name: string, formik: FormikValues) => !!(formik.touched[name] && formik.errors[name]);

export const getFormErrorMessage = (name: string, formik: FormikValues) => {
    return isFormFieldValid(name, formik) && <small className="p-error">{formik.errors[name]}</small>;
};